import {h, Fragment} from "preact"
import Product from "./Product";
import { init, useAppState, useProductFilters } from "@nosto/preact";
import { useEffect, useState } from "preact/hooks";

export default function Products() {
    const { filters } = useProductFilters()

    const {
        response: { products },
        loading
    } = useAppState();
    const [banners, setBanners] = useState([]);
    const [isBannersLoaded, setIsBannersLoaded] = useState(false);
    const [lid, setLid] = useState();

    function createWishlist() {
        let listConfig = {
            "lname": "My Wishlist", 
        };
        
        let onSuccess = function(newList) { 
            setLid(newList.lid)
        }
        
        let onError = function(error) {
            console.error("Error while creating a List", error);
        }
        
        _swat.createList(listConfig, onSuccess, onError);
    }

    function getWishlist() {
        let onSuccess = function(lists) {
            if (lists.length == 0) {
                createWishlist()
            } else {
                setLid(lists[0].lid)
            }
        }
        
        let onError = function(error) {
            console.error("Error while fetching all Lists", error);
        }
        
        _swat.fetchLists({
            callbackFn: onSuccess,
            errorFn: onError
        });
    }

    async function fetchCollectionBanner() {
        try {
            const html = await window.getBanners(window.location.pathname);
            if (typeof html !== "string") {
                throw new Error("El HTML obtenido no es una cadena válida.");
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const scriptElement = doc.querySelector('script[data-product-modal-json]');
            if (!scriptElement) {
                throw new Error("El elemento con 'data-product-modal-json' no fue encontrado.");
            }

            const jsonDataString = scriptElement.textContent;
            const jsonData = JSON.parse(jsonDataString);

            return jsonData.banners;
        } catch (error) {
            console.error("Error obteniendo los banners:", error);
            return [];
        }
    }

    useEffect(() => {
        getWishlist()
        async function initializeBanners() {
            const bannersData = await fetchCollectionBanner();
            setBanners(bannersData);
            setIsBannersLoaded(true);
        }

        initializeBanners();
    }, [lid]);

    useEffect(() => {
        if (document.setATC) {
            document.setATC();
        } else {
            console.warn("document.setATC no está definido");
        }

        nostojs(api => api.createRecommendationRequest()
            .setElements(['image-swap'])
            .load()
        )
    }, [products]);
    // console.log({filters})

    return (
        <div class="ns-d-flex ns-flex-wrap" style={loading ? "opacity: 0.3;" : ""} data-abtest="tested">
            {banners
                .filter(banner => banner.full_width)
                .map((banner, indexBanner) => (
                    <div
                        key={indexBanner}
                        class="ns-product ns-border-box ns-text-undecorated ns-color-inherit ns-col-12 ns-pt-2 ns-px-2 ns-mx-0"
                    >
                        <div class="ns-relative pd-card-container">
                            <a href={banner.url ? banner.url : "#"} class={`pd-image-container pd-banner-container pd-banner-container--full-width ${!banner.url ? "pd-pointer-none" : ""}`}>
                                <img
                                    class="pd-product-image--banner"
                                    src={banner.image}
                                    alt="banner"
                                />
                            </a>
                        </div>
                    </div>
                ))}
            {products.hits.map((hit, index) => (
                <>
                    {filters.length > 0 ? (
                        (() => {
                            const hasSizeFilter = filters.some(filter =>
                                filter.name === "Clothing Size" || filter.name === "Shoe Size"
                            );

                            if (hasSizeFilter) {
                                const isAvailable = hit.skus.find(sku =>
                                    filters.some(filter =>
                                        (filter.name === "Clothing Size" || filter.name === "Shoe Size") &&
                                        filter.value === sku.name &&
                                        (sku.availability !== "OutOfStock" || sku.inventoryLevel > 0)
                                    )
                                );

                                return isAvailable ? <Product product={hit} key={hit.productId || index} lid={lid} /> : null;
                            }

                            return <Product product={hit} key={hit.productId || index} lid={lid} />;
                        })()
                    ) : (
                        <Product product={hit} key={hit.productId || index} lid={lid} />
                    )}




                    {banners
                        .filter(banner => {
                            let initial = products.from || 0
                            let final = initial + products.size
                            let indexBan = index + initial
                            if (banner.position === indexBan && banner.position >= initial && banner.position <= final && !banner.full_width) {
                                return banner
                            }
                        }
                        )
                        .map((banner, indexBanner) => (
                            <div
                                key={indexBanner}
                                class="ns-product ns-border-box ns-text-undecorated ns-color-inherit ns-col-12 ns-col-xs-6 ns-col-md-4 ns-col-l-3 ns-p-2 ns-my-2 ns-mx-0"
                            >
                                <div class="ns-relative pd-card-container">
                                    <a href={banner.url} class="pd-image-container pd-banner-container">
                                        <img
                                            class="pd-product-image"
                                            src={banner.image}
                                            alt="banner"
                                            width="600"
                                            height="500"
                                        />
                                    </a>
                                </div>
                            </div>
                        ))}
                </>
            ))}
        </div>
    );
}
